import { Row, SortingFn } from '@tanstack/react-table'

/**
 * Sorting function for numeric columns
 */
export const createNumberSortFn = <T>(columnId: string): SortingFn<T> => {
  return (rowA: Row<T>, rowB: Row<T>) => {
    const valueA = ((rowA.original as Record<string, unknown>)[columnId] as number) || 0
    const valueB = ((rowB.original as Record<string, unknown>)[columnId] as number) || 0
    return valueA - valueB
  }
}

/**
 * Sorting function for date/datetime columns
 */
export const createDateSortFn = <T>(columnId: string): SortingFn<T> => {
  return (rowA: Row<T>, rowB: Row<T>) => {
    const dateA = new Date((rowA.original as Record<string, unknown>)[columnId] as string)
    const dateB = new Date((rowB.original as Record<string, unknown>)[columnId] as string)
    return dateA.getTime() - dateB.getTime()
  }
}

/**
 * Sorting function for string columns (default)
 */
export const createStringSortFn = <T>(columnId: string): SortingFn<T> => {
  return (rowA: Row<T>, rowB: Row<T>) => {
    const valueA = ((rowA.original as Record<string, unknown>)[columnId] as string)?.trim() || ''
    const valueB = ((rowB.original as Record<string, unknown>)[columnId] as string)?.trim() || ''
    return valueA.localeCompare(valueB)
  }
}

/**
 * Gets the appropriate sorting function based on column configuration
 */
export const getSortingFn = <T>(columnId: string, editingType?: string, editingFormat?: string): SortingFn<T> => {
  if (['number', 'integer'].includes(editingType ?? '')) {
    return createNumberSortFn<T>(columnId)
  }

  if (['datetime', 'date-time', 'date'].includes(editingFormat ?? '')) {
    return createDateSortFn<T>(columnId)
  }

  return createStringSortFn<T>(columnId)
}
